const leftPositionModifier = 535;
const topPositionModifier = 192;
const width = '640px';
const height = '700px';

export const opinionLabDimensions = {
  getLeft: (width: number) => (width - leftPositionModifier) / 2,
  getTop: (height: number) => (height - topPositionModifier) / 2,
  width,
  height
};
